module.exports = __webpack_public_path__ + "img/54.64a11112.svg";